module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34 36\"><path d=\"M32 8.7V31c0 1.7-1.3 3-3 3H5c-1.7 0-3-1.3-3-3V7c0-1.7 1.3-3 3-3h18.7L25 2H5C2.2 2 0 4.2 0 7v24c0 2.8 2.2 5 5 5h24c2.8 0 5-2.2 5-5V7c0-.3 0-.6-.1-.9L32 8.7z\" fill=\"#949494\"/><path d=\"M32 .3c-.9-.6-2.1-.3-2.7.6L16.6 19l-6.3-5.5c-.7-.6-1.8-.7-2.6-.1-.9.7-1 1.9-.3 2.8l8 10c.4.5 1 .8 1.6.8h.1c.7 0 1.2-.4 1.6-1l14-23c.6-.9.3-2.1-.7-2.7z\" fill=\"#FF7500\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./icons/hookSquare.svg
// module id = 60
// module chunks = 0